module.exports = __webpack_public_path__ + "static/media/SWSCRC1-04.f4aa006e.mp3";